import Image from "@Components/Image";
import CustomLink from "@Components/CustomLink";
import {
  APP_DOWNLOAD_APP_STORE_IMG,
  APP_DOWNLOAD_APP_STORE_LINK,
  APP_DOWNLOAD_PLAY_STORE_IMG,
  APP_DOWNLOAD_PLAY_STORE_LINK,
  APP_DOWNLOAD_QR_OFFER_SECTION,
  PAGE,
} from "constants/configConstants";
import { data } from "../data";
import styles from "./AppPromotionContent.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";
import useTranslationHook from "hooks/useTranslationHook";

export const AppPromotionContent = ({ page = PAGE.INVENTORY }) => {
  const { t } = useTranslationHook();
  const appDownloadQR = APP_DOWNLOAD_QR_OFFER_SECTION[page];
  return (
    <div className={styles.container}>
      <div className={styles.qrContainer}>
        <div className={styles.title}>
          {t("propertypage.components.listitem.components.apppromotioncontent.title")}
        </div>

        <div className={styles.qrbackground}>
          <Image src={appDownloadQR} alt="app QR" height={204} width={204} />
        </div>
      </div>
      <div className={styles.rightContainer}>
        {data.map((value, index) => (
          <div key={`app_advantage_${index}`} className={styles.listContainer}>
            {value.icon}
            <div className={styles.text}>
              <b>{t(value.boldText)}</b> {t(value.text)}
            </div>
          </div>
        ))}
        <div className={styles.footerContainer}>
          <div className={styles.text}>
            {t("propertypage.components.listitem.components.apppromotioncontent.download")}
            <strong>{t("download")}</strong>{" "}
            {t("propertypage.components.listitem.components.apppromotioncontent.from")}
          </div>
          <div className={styles.storeContainer}>
            <CustomLink rel="noreferrer" target="_blank" href={APP_DOWNLOAD_PLAY_STORE_LINK}>
              <Image src={APP_DOWNLOAD_PLAY_STORE_IMG} alt="play store" width={176} height="auto" />
            </CustomLink>
            <CustomLink rel="noreferrer" target="_blank" href={APP_DOWNLOAD_APP_STORE_LINK}>
              <Image src={APP_DOWNLOAD_APP_STORE_IMG} alt="app store" width={176} height="auto" />
            </CustomLink>
          </div>
        </div>
      </div>
    </div>
  );
};

export default wrapperHOC(AppPromotionContent, {
  componentName: "AppPromotionContent-ListItem-PropertyPage",
  showForChina: true,
});
